import { useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useHeaderContext } from "../../../context/headerContext";
import { format } from "date-fns";
import MilestoneProgressBar from "../../../components/MilestoneProgressBar";

export default function Milestone() {
  const { setTitle, setBackButton, setBackButtonFunc } = useHeaderContext();
  const { state } = useLocation();
  const { milestone, selectedParticipant } = state;
  const navigate = useNavigate();

  useEffect(() => {
    setTitle(milestone?.MilestoneName);
    setBackButton(true);
  }, []);

  useEffect(() => {
    const handleBack = () => {
      navigate('/milestones', { 
        replace: true, //replace the current history entry
        state: { selectedParticipant } 
      });
    };

    setBackButtonFunc(handleBack);

    return () => {
      setBackButtonFunc(null);
    };
  }, [selectedParticipant]);

  return (
    <div className="flex flex-col gap-5">
      <div>
        <div className="relative h-[197px] w-full mb-[2.46px] z-10">
          {milestone?.AwardedCount >= milestone?.AwardedAfterEvents && (
            <span className="absolute top-0 right-5 bg-[#69B200] bg-[center_bottom_9.85px] rounded-b-[6px] w-8 h-10 bg-[url('/images/icons/tickWhite.svg')] bg-no-repeat bg-[length:16px_12.31px]"></span>
          )}
          <img
            src={milestone?.DirectoryDisplayImage}
            className="block h-[197px] w-full object-cover rounded border-solid border-[1px] border-[#E3E3E3]"
          />
        </div>
        <img
          src={milestone?.MilestoneBadgeURL}
          width={100}
          height={136.54}
          className="-mt-[68.27px] ml-[21px] z-20 relative"
        />
      </div>
      <div className="pb-5 border-b-[1px] border-[#E3E3E3] border-dashed">
        <h2 className="mb-1 text-[#1E1E1E]">{milestone?.MilestoneName}</h2>
        <h4 className="text-sportsDarkGrey">{milestone?.MilestoneDescription}</h4>
      </div>
      <div className="flex flex-col gap-5">
        {milestone?.WhenAchieved === "" ? (
          <div className="flex flex-col">
            <p className="text-sportsDarkGrey">Progress at {milestone?.DirectoryDisplayName}</p>
            <MilestoneProgressBar progress={milestone} />
          </div>
        ) : (
        <div className="">
          <h4 className="text-[#1E1E1E]">Completed at {milestone?.DirectoryDisplayName}</h4>
          <p className="text-sportsDarkGrey">
            {milestone?.WhenAchieved && !isNaN(new Date(milestone.WhenAchieved).getTime()) 
              ? format(new Date(milestone.WhenAchieved), "dd/MM/yyyy")
              : ''}
          </p>
        </div>
        )}
      </div>
    </div>
  );
}
